/**
 * @generated SignedSource<<85793bfef3f0eb98452fcf155d20e31e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4RoadmapsWithRecent_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapNavExpanded_query">;
  readonly " $fragmentType": "Nav4RoadmapsWithRecent_query";
};
export type Nav4RoadmapsWithRecent_query$key = {
  readonly " $data"?: Nav4RoadmapsWithRecent_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4RoadmapsWithRecent_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4RoadmapsWithRecent_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RoadmapNavExpanded_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "468aac4b59c904dc566a05789c11dc6a";

export default node;
